<div>

  <div class="d-flex justify-content-center align-items-center" *ngIf="loading" style="height: 20vh;">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>

  <ngx-paypal [config]="payPalConfig" [hidden]="loading"></ngx-paypal>

</div>
